export function buildSummedGeneralInformation(tab) {
    return {
        hasNamesColumn: false,
        headerRow: [],
        rows: {
            'first-row': {
                valueCells: [{
                    unit: '',
                    type: 'number',
                    editable: false,
                    styleClasses: 'just-border-top bold bg-krem',
                    getComputedValue(tabs) {
                        let completedRows = 0;
                        const rows = tabs[tab].tables['general-information'].rows;
                        Object.values(rows).forEach((row) => {
                            completedRows = row.valueCells[2].value ? completedRows + 1 : completedRows;
                        });

                        return {internalValue: completedRows, displayValue: `Total Tenants: ${completedRows.toLocaleString()}`};
                    },
                },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue() {
                            const value = 'Occupied';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'just-border-top bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue(tabs) {
                            const rows = tabs[tab].tables['sumed-general-information'].rows;
                            const vacantValue = rows['second-row'].valueCells[2].getComputedValue(tabs)['internalValue'] ? rows['second-row'].valueCells[2].getComputedValue(tabs)['internalValue'] : 0;
                            const totalValue = rows['third-row'].valueCells[2].getComputedValue(tabs)['internalValue'] ? rows['third-row'].valueCells[2].getComputedValue(tabs)['internalValue'] : 0;
                            const occupiedValue = totalValue - vacantValue;

                            return {internalValue: occupiedValue, displayValue: `${occupiedValue.toLocaleString()}`};
                        },
                    }]
            },
            'second-row': {
                valueCells: [
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue() {
                            const value = 'Vacant';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['general-information'].rows;
                            Object.keys(rows).forEach((key) => {
                                if (rows[key].isHighlighted(tabs, key)) {
                                    sum = rows[key].valueCells[2].value ? sum + parseFloat(rows[key].valueCells[2].value) : sum;
                                }
                            });

                            return {internalValue: sum, displayValue: `${sum.toLocaleString()}`};
                        },
                    }]
            },
            'third-row': {
                valueCells: [
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bg-krem',
                        getComputedValue() {
                            return {internalValue: '', displayValue: ''};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'borderless bold bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue() {
                            const value = 'Total';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'number',
                        editable: false,
                        styleClasses: 'borderless bold bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue(tabs) {
                            let sum = 0;
                            const rows = tabs[tab].tables['general-information'].rows;
                            Object.values(rows).forEach((row) => {
                                sum = row.valueCells[2].value ? sum + parseFloat(row.valueCells[2].value) : sum;
                            });

                            return {internalValue: sum, displayValue: `${sum.toLocaleString()}`};
                        },
                    }]
            },
            'fourth-row': {
                valueCells: [{
                    unit: '',
                    type: 'number',
                    editable: false,
                    styleClasses: 'just-border-bottom bg-krem',
                    nameClasses: 'font-gotham-bold font-size-9',
                    getComputedValue() {
                        const value = '';
                        return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                    },
                },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue() {
                            const value = '';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    },
                    {
                        unit: '',
                        type: 'text',
                        editable: false,
                        styleClasses: 'just-border-bottom bg-krem',
                        nameClasses: 'font-gotham-bold font-size-9',
                        getComputedValue() {
                            const value = '';
                            return {internalValue: value, displayValue: `${value.toLocaleString()}`};
                        },
                    }]
            },
        },
    }
}
